// servizi/giorniSalvati.ts — v037: i giorni in cui ho giocato, salvati sul telefono (vedi giorni.ts).
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";
import { conGiorno, giornoLocale, serieGiorni } from "./giorni.ts";

export function giorniGiocati(): string[] {
  try {
    const v = JSON.parse(leggiPreferenza(PREFERENZE.giorniGiocati) ?? "[]") as unknown;
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === "string" && /^\d{4}-\d{2}-\d{2}$/.test(x)) : [];
  } catch {
    return [];
  }
}

/** Una partita finita oggi. */
export function registraGiorno(d = new Date()): void {
  salvaPreferenza(PREFERENZE.giorniGiocati, JSON.stringify(conGiorno(giorniGiocati(), d)));
}

export const serieAttuale = (oggi = new Date()) => serieGiorni(giorniGiocati(), oggi);

/** v040: la partita del giorno fatta, da festeggiare in Home una volta (poi il riquadro sparisce). */
export function daFesteggiare(oggi = new Date()): boolean {
  return giorniGiocati().includes(giornoLocale(oggi)) && leggiPreferenza(PREFERENZE.giornoFesteggiato) !== giornoLocale(oggi);
}
export const segnaFesteggiato = (oggi = new Date()) => salvaPreferenza(PREFERENZE.giornoFesteggiato, giornoLocale(oggi));
